var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRefsContext } from "@/contexts/ref";
import { Box } from "@gemini/core";
import { useBrandUrl } from "@/hooks";
export const AddressTestId = "cdp-location-address";
export const AddressWrapper = (_a) => {
    var { children, isLink, fontSize, showIcon } = _a, restBoxProps = __rest(_a, ["children", "isLink", "fontSize", "showIcon"]);
    const addressPlaceholderUrl = useBrandUrl({
        endpoint: "/shared/images/map/address-map.png",
    });
    const { locationRef } = useRefsContext();
    const scrollToLocationSection = () => {
        locationRef === null || locationRef === void 0 ? void 0 : locationRef.current.scrollIntoView({ behavior: "smooth" });
    };
    return (
    // @ts-ignore
    _jsxs(Box, Object.assign({ as: isLink ? "button" : "div", display: "flex", gap: "spacing.12", alignItems: "center", testId: AddressTestId, height: isLink ? "sizing.40" : null, typography: `typography.body.${fontSize}.regular${isLink ? "Underlined" : ""}`, onClick: isLink ? scrollToLocationSection : undefined, cursor: isLink ? "pointer" : null, borderStyle: "hidden" }, restBoxProps, { children: [showIcon && (_jsx(Box, { as: "img", src: addressPlaceholderUrl, alt: "address-icon", height: "sizing.40", width: "sizing.40", borderRadius: "radius.8" })), _jsx(Box, { display: "flex", flexWrap: "wrap", borderStyle: "hidden", children: children })] })));
};
